"use client";
import { useState, useEffect } from "react";
import { Modal, Input, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import styles from './Login.module.scss';
import classNames from "classnames";
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import { RootState } from '../../../redux/reducers/index';
import { sendOtp } from '../../../redux/api/request/loginThunk';
import { resetOtp } from '../../../redux/reducers/request/loginReducer';
import { resetToken } from '@/redux/reducers/request/tokenReducer';
import { signUp } from '../../../redux/api/request/signupThunk';
import { receiveToken, TokenPayload } from '../../../redux/api/request/tokenThunk';
import {saveFirebase} from '@/redux/api/firebaseThunk';
// import Cookies from 'js-cookie';
import Image from 'next/image';
import logo from '../../../../public/Brand-logo.png';
import { useRouter } from "next/navigation";
import { usePathname } from "next/navigation";
import { decodeToken } from '../../../utils/jwtDecode';
import Link from "next/link";
import { initFirebaseMessaging } from '@/lib/firebase';
import {useDeviceDetection} from '@/hooks/useDeviceDetection';
import PasswordModal from '@/components/PasswordModal/PasswordModal';
import { ROUTES } from '@/lib/routes';


interface LoginModalProps {
    visible: boolean;
    onClose: () => void;
    isSignUp: boolean;
    setIsSignup: React.Dispatch<React.SetStateAction<boolean>>;
}

const Login: React.FC<LoginModalProps> = ({ visible, onClose, isSignUp, setIsSignup }) => {

    const [email, setEmail] = useState<string>("");
    const [otp, setOtp] = useState<string>("");
    const [isOtpModalVisible, setIsOtpModalVisible] = useState(false);
    const [errMessage, setErrMessage] = useState<string>("");
    const [resendTimer, setResendTimer] = useState(180);
    const router = useRouter();
    const pathname = usePathname();
    const firebaseMessaging = initFirebaseMessaging();
    const device = useDeviceDetection();

    const dispatch = useDispatch<AppDispatch>();
    const {access} = useSelector((state: RootState) => state.setting);
    const { isLoading, isError, error } = useSelector((state: RootState) => state.otp);
    const {isLoading:Firebaseloading } = useSelector((state: RootState) => state.firebase);
    const { loading, error: tokenError, isError: tokenIsError } = useSelector((state: RootState) => state.token);

    useEffect(() => {
        if (resendTimer > 0) {
            const timer = setInterval(() => {
                setResendTimer((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [resendTimer]);

    const formatTimer = () => {
        const minutes = Math.floor(resendTimer / 60);
        const seconds = resendTimer % 60;
    
        if (minutes === 0) {
            return `${seconds} sec`;
        }
    
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds} min`;
    };
    
    const handleEmailSubmit = () => {

        if (!email.trim()) {
            setErrMessage("Email field cannot be empty.");
            return;
        }
        setErrMessage("");

        if (isSignUp) {
            dispatch(signUp({ email })).then((result) => {
                if (result.meta.requestStatus === 'fulfilled') {
                    setIsOtpModalVisible(true);
                    dispatch(resetOtp());
                }
            });
        } else {
            dispatch(sendOtp({ email })).then((result) => {
                if (result.meta.requestStatus === 'fulfilled') {
                    setIsOtpModalVisible(true);
                    dispatch(resetOtp());
                }
            });
        }
    };

    const handleResendOtp = () => {
        dispatch(resetToken());
        dispatch(sendOtp({ email })).then((result) => {
            if (result.meta.requestStatus === 'fulfilled') {
                dispatch(resetOtp());
                setResendTimer(180);
            }
        });
    };

    const handleLinkdIn = () => {
        const linkedInUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.NEXT_PUBLIC_CLIENT_ID}&redirect_uri=${process.env.NEXT_PUBLIC_REDIRECT_URI}&scope=openid%20profile%20email`;
        window.location.href = linkedInUrl;
    };

    const handleModalClose = () => {
        dispatch(resetOtp());
        dispatch(resetToken());
        onClose();
    }

    const toggleSignUp = () => {
        setIsSignup(prev => !prev)
    }

    const handleOtpSubmit = async () => {
        if (!otp.trim()) {
            setErrMessage("OTP field cannot be empty.");
            return;
        }
        setErrMessage("");
        try {
            const result = await dispatch(receiveToken({ otp, email }));
            if (result.meta.requestStatus === 'fulfilled') {
                const payload = result.payload as TokenPayload;
                if (payload && payload.data.token) {
                    const decodedToken = decodeToken(payload.data.token);
                    localStorage.setItem('email', decodedToken.email);
                    localStorage.setItem('profile_picture', decodedToken.profile_picture);
                    localStorage.setItem('name', decodedToken.name);
                    localStorage.setItem('slug', decodedToken.slug);
                    localStorage.setItem('position', decodedToken.position);
  
                    localStorage.setItem('fcm_stored',"true");

                    if(firebaseMessaging){
                    const fcm_token = await firebaseMessaging.requestPermission() || "";
                    const device_info = `${device.browser} on ${device.deviceType} `
                    await dispatch(saveFirebase({fcm_token,device_info}));
                    onClose();
                    }
    
                    let targetUrl = "/";
                    if (isSignUp) {
                        targetUrl = `${ROUTES.REGISTRATION}/profile-details`;
                        
                    } else {
                        switch (payload.action) {
                            case "profile":
                            case "step-1":
                            case "step-2":
                            default:
                                targetUrl = `${ROUTES.dynamic.Profile(payload.data.slug)}`;
                                break;
                        }
                    }
    
                    if (pathname === targetUrl) {
                        window.location.reload();
                    } else {
                        sessionStorage.setItem("reload", "true");
                        router.push(targetUrl);
                    }
                    
                    dispatch(resetToken());
                    
                 }
            }
        } catch (error) {
            setErrMessage("An error occurred while submitting OTP.");
        }
    };


    return (
        <>
        {
          (access === true || !isSignUp) ?
            (
            <>
            <Modal
                open={visible && !isOtpModalVisible}
                footer={null}
                onCancel={handleModalClose}
                centered
                maskClosable={false}
                keyboard={false}
                width="400px"
            >
                <div className={classNames(styles.loginContainer, 'primary_font')}>

                    <div>
                        <Image src={logo} alt="Candidate Review" priority />
                    </div>

                    <div>
                        <h2 className={classNames(styles.login_header, 'primary_font', 'primary_text_color')} >

                            {isSignUp ? "Sign up " : "Sign in "}
                            to access the best of Candidate Review
                        </h2>


                        <div className={classNames(styles.input_header, 'primary_font', 'grey_text_color')}>Enter your email</div>
                        <div>
                            <Input
                                placeholder="Your Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className={classNames(
                                    styles.login_email,
                                    { [styles.error_border]: isError || errMessage }
                                )}
                            />

                            {isError && <p className={classNames(styles.error_message)}>{error}</p>}
                            {errMessage && <p className={classNames(styles.error_message)}>{errMessage}</p>}

                        </div>


                    </div>



                    <div>
                        <button
                            onClick={handleEmailSubmit}
                            className={classNames(styles.login_btn, 'primary_font', 'secondary_background')}
                            disabled={isLoading}
                        >
                            Continue with email {isLoading && <Spin indicator={<LoadingOutlined spin />} style={{ color: "white", marginLeft: "4px" }} />}
                        </button>

                        <button
                            onClick={handleLinkdIn}
                            className={classNames(styles.LinkedIn_btn, 'primary_font')}
                            disabled={isLoading}
                        >
                            Continue with LinkedIn
                        </button>

                        <p className={classNames(styles.signup, 'primary_font', 'common_text_color2')}>
                            <span>
                                {isSignUp ? "Already Have an Account? " : "Don’t Have an Account? "} {" "}
                            </span>

                            <a href="#" onClick={toggleSignUp}>
                                {isSignUp ? "Sign In" : "Sign Up"}
                            </a>

                        </p>

                        <p className={classNames(styles.policy, 'primary_font', 'common_text_color2')}>
                            By continuing, you agree to our
                            <Link href="/terms-of-use" target="_blank" rel="noopener noreferrer"> Terms of Use</Link>
                        </p>

                    </div>

                </div>
            </Modal>

            <Modal
                open={visible && isOtpModalVisible}
                footer={null} onCancel={handleModalClose}
                width="400px"
                centered
                maskClosable={false}
                keyboard={false}
            >
                <div className={classNames(styles.loginContainer, 'primary_font')}>

                    <div>
                        <Image src={logo} alt="Candidate Review" priority />
                    </div>

                    <div className={classNames(styles.otp_header, 'primary_font', 'primary_text_color')}>Enter OTP </div>

                    <p className={classNames(styles.otp_description, 'primary_font', 'primary_text_color')}>
                        We've sent a One-Time Password (OTP) to your email. Please check your inbox and enter the code to proceed.
                    </p>

                    <div className={classNames(styles.otp_box)}>
                        <Input
                            placeholder='Enter OTP'
                            onChange={(e) => setOtp(e.target.value)}
                            className={classNames(styles.login_email, 'text-500', 'text16', { [styles.error_border]: tokenIsError || errMessage })}
                            inputMode="numeric"
                            pattern="\d*"
                        />


                        {resendTimer > 0 ? (
                            <p className={classNames(styles.resend_otp, 'primary_font','underline')}>
                                Your Verification Code Expires in <span style={{fontWeight:"600"}}>{formatTimer()}</span>
                            </p>
                        ) : (
                            <p
                                className={classNames(styles.resend_otp, 'primary_font','underline')}
                                onClick={handleResendOtp}
                            >
                                Resend Code
                            </p>
                        )}

                        {tokenIsError && <p className={classNames(styles.error_message)}>{tokenError}</p>}
                        {errMessage && <p className={classNames(styles.error_message)}>{errMessage}</p>}

                    </div>

                    <button
                        onClick={handleOtpSubmit}
                        className={classNames(styles.login_btn, 'secondary_font', 'secondary_background')}
                        disabled={loading || Firebaseloading}
                    >
                        Continue {(loading || Firebaseloading) && <Spin indicator={<LoadingOutlined spin />} style={{ color: "white", marginLeft: "4px" }} />}
                    </button>


                    {/* <p className={classNames(styles.policy, 'text-popin', 'text-400', 'text10')}>
                        By proceeding, you agree to our
                        <a href="#"> Terms of Use</a> and confirm you have read our
                        <a href="#"> Privacy and Cookie Statement.</a>.
                    </p> */}
                </div>
            </Modal>
          </>
            ) 
            : 
            (
            <PasswordModal visible={visible} onClose={handleModalClose}/>
            )
        }

        </>
    );
};

export default Login;
